import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT

//批量添加购物车
export const saveshopping = (params) => {
  return axios.post(root + '/order/shoppingtrolley/save', qs.stringify(params))
}
//立即购买（）
export const sofortkaufen = (params) => {
  return axios.post(root + '/order/shoppingtrolley/sofortkaufen', qs.stringify(params))
}
//根据groupguid查询数据
export const getFormproperty = (params) => {
  return axios.post(root + '/order/shoppingtrolley/getFormproperty', qs.stringify(params))
}
//修改
export const updateData = (params) => {
  return axios.post(root + '/order/shoppingtrolley/update', qs.stringify(params))
}


export const orderView = (params,needPrint) => {
  if(needPrint)
    return root + '/api/pdf/orderPrint?print=1&sellguid=' + params.groupguid;
  else{
    return root + '/api/pdf/orderPrint?hidemobile=1&fromback=1&sellguid=' + params.groupguid;
  }
}




// WEBPACK FOOTER //
// ./src/api/order/shopping.js